import { useEffect } from "react";
import { create } from "zustand";

import type { ToolId } from "@/shared/config/tools";

/**
 * Колесо тулзов (KAN-867): открыто ли меню и не запрещено ли оно сейчас.
 *
 * Запрет — счётчик, а не флаг: экранов-исключений несколько (пик в драфте,
 * подтверждение результата матча), они монтируются независимо, и закрытие
 * одного не должно снимать запрет, выставленный другим.
 */
interface ToolWheelState {
  isOpen: boolean;
  suppressors: number;
  /** Инструмент, чья мини-модалка открыта (KAN-868); null — закрыта. */
  activeTool: ToolId | null;
  openTool: (tool: ToolId) => void;
  closeTool: () => void;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const useToolWheelStore = create<ToolWheelState>((set, get) => ({
  isOpen: false,
  suppressors: 0,
  activeTool: null,
  openTool: (tool) => set({ isOpen: false, activeTool: tool }),
  closeTool: () => set({ activeTool: null }),
  open: () => {
    if (get().suppressors === 0) set({ isOpen: true });
  },
  close: () => set({ isOpen: false }),
  toggle: () => {
    const { isOpen, suppressors } = get();
    if (isOpen) set({ isOpen: false });
    else if (suppressors === 0) set({ isOpen: true });
  },
}));

/**
 * Экран, где колесо мешает (активный пик, подтверждение результата), вызывает
 * этот хук: пока экран смонтирован, хоткей и кнопка колесо не открывают, а уже
 * открытое закрывается.
 */
export function useSuppressToolWheel(active = true) {
  useEffect(() => {
    if (!active) return;
    useToolWheelStore.setState((s) => ({
      suppressors: s.suppressors + 1,
      isOpen: false,
      activeTool: null,
    }));
    return () => {
      useToolWheelStore.setState((s) => ({
        suppressors: Math.max(0, s.suppressors - 1),
      }));
    };
  }, [active]);
}
